import BaseAbility from 'umg-ember-backend/abilities/base';

export default class AudioplayerTrackAbility extends BaseAbility {
  get permissions() {
    return this.permission.for('audioplayer');
  }
}
